import { getChainShortDisplayName, getChainSymbol } from '@passkeys/assets';
import Badge from '@passkeys/ui/badge';
import ChainIcon from '@passkeys/ui/chain-icon';

import useAsset from '@/ui/hooks/use-asset';
import { cn } from '@/ui/utils/classnames';

type ChainBadgeProps = {
  name: string;
  className?: string;
  compact?: boolean;
  size?: 'small' | 'medium';
  iconOnly?: boolean;
};

function ChainBadge({
  name,
  className,
  compact = false,
  size = 'small',
  iconOnly = false,
}: ChainBadgeProps) {
  const asset = useAsset(name);
  if (!asset) {
    throw new Error(`${name} is not supported`);
  }

  const displayName = compact
    ? getChainSymbol(asset)
    : getChainShortDisplayName(asset);

  return (
    <Badge
      className={cn(
        'flex-none gap-x-1 font-sans uppercase',
        iconOnly ? 'w-5 p-0' : 'pl-0.5',
        size === 'medium' ? 'h-[28px]' : 'h-5',
        className,
      )}
      dataTestId="chain-badge"
    >
      <ChainIcon
        name={name}
        displayName={displayName}
        size={size === 'medium' ? 24 : 16}
        noShadow
        className="rounded-full"
      />
      {!iconOnly && displayName}
    </Badge>
  );
}

export default ChainBadge;
